export default "__VITE_ASSET__BkaGAjzF__"